import { useState, useContext, useEffect } from 'react';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as Utilities from '../../../Components/Utils/Utils';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";
import * as KeyNames from '../../../api/KeyNames';
import VacancyCard from '../../../Components/Cards/VacancyCard';

export default function IndicadoresPrinciaples() {

    let [indicadoresPrincipales, setIndicadoresPrincipales] = useState({
        date: null,
        mall_santaAnita: {
            vacancy: null,
            ventas: {
                value: null,
                variation: null,
            }
        },
        mall_arequipa: {
            vacancy: null,
            ventas: {
                value: null,
                variation: null,
            }
        },
        mall_chiclayo: {
            vacancy: null,
            ventas: {
                value: null,
                variation: null,
            }
        },
        mall_iquitos: {
            vacancy: null,
            ventas: {
                value: null,
                variation: null,
            }
        },
        mall_sjl: {
            vacancy: null,
            ventas: {
                value: null,
                variation: null,
            }
        },
        total: {
            vacancy: null,
            ventas: {
                value: null,
                variation: null,
            }
        }
    });

    const token = useGetToken();

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError } = useQuery([KeyNames.SessionData, indicadoresPrincipales],
        async () => await Api.DashboardIndicadoresPrincipales({ "token": token })
    );

    useEffect(() => {
        if (data) {
            if (/* !data.success || */data.data === null) { // 2do release. El data.success sirve para ver si la consulta da o no resultado, así que no se valida aquí.
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
            else if (data.data)
                setIndicadoresPrincipales(data.data);
        }
    }, [data]);

    if (isLoading || isLoading) return (<Loading />)
    if (isError || isError) return (<ErrorConnection error={isError/*.response.status*/} />)

    return (
        <>
            <h5>Vacancy al {indicadoresPrincipales.date}</h5>
            <div className="row g-3 g-xl-4 flex-wrap d-flex flex-row">

                {/* Mall Santa Anita */}
                <div className="col-12 col-md-6 col-lg-4 container-vacancy-card">
                    <VacancyCard
                        mall="Mall Santa Anita"
                        value={Utilities.comillasFix(indicadoresPrincipales.mall_santaAnita.vacancy, true, 0)}
                    />
                </div>

                {/* Mall Arequipa */}
                <div className="col-12 col-md-6 col-lg-4 container-vacancy-card">
                    <VacancyCard
                        mall="Mall Arequipa"
                        value={Utilities.comillasFix(indicadoresPrincipales.mall_arequipa.vacancy, true, 0)}
                    />
                </div>

                {/* Mall Chiclayo */}
                <div className="col-12 col-md-6 col-lg-4 container-vacancy-card">
                    <VacancyCard
                        mall="Mall Chiclayo"
                        value={Utilities.comillasFix(indicadoresPrincipales.mall_chiclayo.vacancy, true, 0)}
                    />
                </div>

                {/* Mall Iquitos */}
                <div className="col-12 col-md-6 col-lg-4 container-vacancy-card">
                    <VacancyCard
                        mall="Mall Iquitos"
                        value={Utilities.comillasFix(indicadoresPrincipales.mall_iquitos.vacancy, true, 0)}
                    />
                </div>

                {/* Mall San Juan de Lurigancho */}
                <div className="col-12 col-md-6 col-lg-4 container-vacancy-card">
                    <VacancyCard
                        mall="Mall San Juan de Lurigancho"
                        value={Utilities.comillasFix(indicadoresPrincipales.mall_sjl.vacancy, true, 0)}
                    />
                </div>

                {/* Totales */}
                <div className="col-12 col-md-6 col-lg-4 container-vacancy-card">
                    <div className="card bg-danger-mall h-100">
                        <div className="card-body">
                            <div className="d-flex text-center flex-column text-red-mall pt-2 h-100 justify-content-between">
                                <span className="fw-bold fs-7">Totales</span>
                                <div className="d-flex align-items-center justify-content-center pt-2">
                                    <span className="fw-bolder fs-2x pt-1">{Utilities.comillasFix(indicadoresPrincipales.total.vacancy, true, 0)}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
